import { Box, Button, Stack, Typography } from "@mui/material";
import { FaceIconBrandLarge } from "@/theme/icons";
import CircledBackButton from "@/features/Common/components/CircledBackButton";

interface VitalManualEntryLayoutProps {
  title: string;
  onBack: () => void;
  onCancel: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
  cancelText: string;
  saveText: string;
  children: React.ReactNode;
}

export default function VitalManualEntryLayout({
  title,
  onBack,
  onCancel,
  onSave,
  isSaveDisabled = false,
  cancelText,
  saveText,
  children,
}: VitalManualEntryLayoutProps) {
  return (
    <Stack
      p={2}
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box
        component="header"
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1,
        }}
      >
        <CircledBackButton onClick={onBack} showLabel={true} />
      </Box>

      <Box marginY={4}>
        <FaceIconBrandLarge />
      </Box>

      <Typography variant="h3" marginBottom={4} lineHeight="150%">
        {title}
      </Typography>

      <Box sx={{ flex: 1 }}>{children}</Box>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
          paddingTop: 2,
          paddingBottom: 4,
          marginTop: "auto",
          marginLeft: -2,
          marginRight: -2,
          marginBottom: -2,
          paddingLeft: 2,
          paddingRight: 2,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          boxShadow:
            "0 4px 100px 0 rgba(40, 44, 80, 0.25), 0 15px 45px 0 rgba(46, 75, 132, 0.27), 0 1.878px 5.635px 0 rgba(46, 75, 132, 0.14)",
        }}
      >
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{ flex: 1, py: 1.5, borderRadius: 2 }}
        >
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaveDisabled}
          sx={{ flex: 1, py: 1.5, borderRadius: 2 }}
        >
          {saveText}
        </Button>
      </Box>
    </Stack>
  );
}
